import { postUserAnalyticsEvent } from "../services/openpanelAnalyticsService";

const OPENPANEL_CLIENT_ID = process.env.REACT_APP_OPENPANEL_CLIENT_ID;
const OPENPANEL_DEBUG = process.env.REACT_APP_OPENPANEL_DEBUG === "true" || process.env.NODE_ENV !== "production";

const isBrowser = typeof window !== "undefined";
const isEnabled = Boolean(OPENPANEL_CLIENT_ID && isBrowser);

let initialized = false;

let currentUserProperties = {};
const SUPER_ADMIN_USER_ID = "1";

export const initAnalytics = () => {
    if (initialized) return;
    initialized = true;
    if (OPENPANEL_DEBUG) {
        console.info("[OpenPanel] analytics initialized", { enabled: isEnabled });
    }
};

const normalizeUserContext = (user = {}) => ({
    user_id: user.user_id ?? user.id ?? user.profileId ?? "",
    user_name: user.user_name ?? user.name ?? "",
    user_email: user.user_email ?? user.email ?? "",
    customer_id: user.customer_id ?? "",
    customer_name: user.customer_name ?? "",
    site_id: user.site_id ?? "",
    site_name: user.site_name ?? "",
    location: user.location ?? "",
    user_role: user.user_role ?? user.role ?? "",
});

const normalizeAnalyticsContext = (context = {}) => ({
    customer_id: context.customer_id ?? "",
    customer_name: context.customer_name ?? "",
    site_id: context.site_id ?? "",
    site_name: context.site_name ?? "",
    location: context.location ?? "",
    user_role: context.user_role ?? "",
});

const isSuperAdminAnalyticsContext = (context = {}) =>
    String(context.user_id ?? context.id ?? context.profileId ?? "").trim() === SUPER_ADMIN_USER_ID;

export const identifyUser = (user = {}) => {
    if (!isEnabled) return;

    if (isSuperAdminAnalyticsContext(user)) {
        currentUserProperties = {};
        return;
    }

    const profileId = user.profileId ?? user.user_id ?? user.id;
    if (!profileId) return;

    currentUserProperties = normalizeUserContext(user);

    if (OPENPANEL_DEBUG) {
        console.info("[OpenPanel] identify", {
            profileId: String(profileId),
            properties: currentUserProperties,
        });
    }
};

export const setAnalyticsContext = (context = {}) => {
    if (!isEnabled) return;
    if (isSuperAdminAnalyticsContext(currentUserProperties)) return;

    currentUserProperties = {
        ...currentUserProperties,
        ...normalizeAnalyticsContext(context),
    };

    if (OPENPANEL_DEBUG) {
        console.info("[OpenPanel] context", currentUserProperties);
    }
};

export const trackEvent = (eventName, metadata = {}) => {
    if (!isEnabled || !eventName) return;
    if (isSuperAdminAnalyticsContext(currentUserProperties) || isSuperAdminAnalyticsContext(metadata)) return;

    const properties = {
        ...currentUserProperties,
        ...metadata,
    };

    if (OPENPANEL_DEBUG) {
        console.info("[OpenPanel] track", { eventName, properties });
    }

    postUserAnalyticsEvent(eventName, properties);
};

export const trackModelOpened = (modelType, metadata = {}) => {
    const normalizedType = String(modelType || "").trim().toUpperCase();
    if (!normalizedType) return;

    trackEvent(normalizedType === "2D" ? "model_2d_opened" : "model_3d_opened", {
        model_type: normalizedType,
        ...metadata,
    });
};

export const resetAnalytics = () => {
    currentUserProperties = {};
};
